import { useState, useEffect } from 'react';

const MD_BREAKPOINT_QUERY = '(min-width: 900px)';

const useResponsive = () => {
    const [isMdUp, setIsMdUp] = useState(
        () => typeof window !== 'undefined' && window.matchMedia(MD_BREAKPOINT_QUERY).matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia(MD_BREAKPOINT_QUERY);
        const handleChange = (event) => setIsMdUp(event.matches);
        mediaQuery.addEventListener('change', handleChange);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);

    return isMdUp;
};

export default useResponsive;